<template>
    <div class="wrapper primary-content">
        <div class="columns is-tablet is-vcentered is-centered">
            <div class="column is-9-tablet">
                <back-button class="mb-5"/>
                <div class="columns is-tablet is-vcentered is-centered">
                    <div class="column is-8-tablet is-7-desktop is-6-fullhd">
                        <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold">Contact us</h1>

                        <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">


                            <div class="contact-form">
                                <ValidationProvider rules="required|email|min:8" v-slot="{ errors,valid }">
                                    <b-field class="mb-5"
                                             :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                             :message="errors">
                                        <b-input v-model="form.email" placeholder="Email address"
                                                 class="field-text-alt"
                                        >
                                        </b-input>

                                    </b-field>
                                </ValidationProvider>
<!--
                                <ValidationProvider rules="required|min:8" v-slot="{ errors,valid }">
                                    <b-field class="mb-5"
                                             :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                             :message="errors">
                                        <b-input v-model="form.Subject" placeholder="Subject"
                                                 class="field-text-alt"
                                        >
                                        </b-input>

                                    </b-field>
                                </ValidationProvider>
-->

                                <ValidationProvider name="confirm" rules="required" v-slot="{ errors,valid }">

                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors"
                                    >

                                        <b-select v-model="form.Subject" class="w-100 is-flex is-justify-content-flex-end mb-5" placeholder="Subject">
                                            <option value="My account">My account</option>
                                            <option value="Registration">Registration</option>
                                            <option value="Report a bug">Report a bug</option>
                                            <option value="Fund data">Fund data</option>
                                            <option value="General enquiry">General enquiry</option>
                                            <option value="Other">Other</option>
                                        </b-select>
                                    </b-field>

                                </ValidationProvider>

                                <ValidationProvider name="txt" rules="required" v-slot="{ errors,valid }">

                                    <b-field
                                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                                        :message="errors"
                                    >
                                    <b-input maxlength="400" v-model="form.msg" type="textarea"></b-input>
                                </b-field>
                                </ValidationProvider>

                                <div v-if="thankyou==1" class="alert alert-success p-t-10 p-b-10 m-b-10">Thanks, we'll get back to you shortly!</div>

                                <b-button :disabled="thankyou==1" @click="submit" class="button is-primary" type="is-primary">SEND</b-button>

                            </div>

                        </ValidationObserver>
                    </div>
                </div>
            </div>
            <div class="column is-12-mobile is-3-tablet">
                <div class="banner-on-top" ref="subRight">
                    <AdsGoogle />
                </div>
            </div>

        </div>
        <div class="columns is-tablet">
            <div class="column is-9-tablet disclaimer">
                <Disclaimer />
            </div>
        </div>


    </div>
</template>
<style scoped>
.about-video {
    @media (min-width: 768px) {
        margin-top: -78px;
    }
}
.alert-success {

    padding: 20px;
    border-radius: 5px;
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
</style>
<script>
// @ is an alias to /src
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import Disclaimer from "@/components/Disclaimer"
import axios from "axios";
import AdsGoogle from '@/components/AdsGoogle.vue';
import bannerMixin from "@/mixins/bannerMixin"


export default {
    name: 'Contactform',
    props: {
        to: Object
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        Disclaimer,
        AdsGoogle
    },
    mixins: [bannerMixin],
    data: function () {
        return {
            form: {
                email: this.$store.state.auth.emailUser,
                Subject: null,
                msg: "",
            }
            ,
            thankyou: 0

        }
    },
    methods: {
        async submit() {

            let token = document.head.querySelector('meta[name="csrf-token"]');

            if (token) {
                window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
            } else {
                //console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
            }

            this.$refs.observer.validate().then(async success => {
                if (!success) {
                    const el = document.querySelector(".help.is-danger:first-of-type");
                    el.scrollIntoView(true);
                    window.scrollBy(0, -150);
                    return;
                }
                await axios.get('/sanctum/csrf-cookie')
                await axios.post("/Contact", this.form).then(response => {

                    if (response.data.re == "success") {
                        this.thankyou = 1
                    }
                })
            })
        }
    },
    metaInfo() {
        return {
            title: "Contact Us | Pickafund",
            meta: [
                { name: 'description', content:  'We are here to answer any question you may have'},
                { property: 'og:title', content: "Contact Us | Pickafund"}
            ]
        }
    },
    watch: {
        '$store.state.auth.emailUser': function (data) {
            this.form.email = data;
        }
    },
    mounted() {
        if(this.$store.state.auth.authenticated && !this.form.email) {
            axios.get("/api/profile").then(response => {
                const profile = response.data
                this.$store.commit("auth/SET_EMAIL", profile.email)
            })
        }
    },
    
}
</script>
